import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  (
    { token },
    props: { isRoot?: boolean; isLabel?: boolean; color: string }
  ) => ({
    flex: {
      display: 'inline-flex'
    },
    card: {
      userSelect: 'none',
      width: props.isRoot ? 300 : 290,
      borderRadius: 8,
      border: 0,
      '::after': {
        content: '""',
        display: props.isLabel ? 'none' : 'block',
        width: 15,
        height: 15,
        borderRadius: '50%',
        border: `2px solid ${token.colorWhite}`,
        background: props.isRoot ? token.colorPrimary : props?.color,
        position: 'absolute',
        left: 'calc(50% - 7px)',
        top: -7,
        zIndex: 1
      }
    },
    countCircle: {
      width: 34,
      zIndex: 1,
      height: 25,
      borderRadius: 16,
      backgroundColor: props.isRoot ? token.primary.primary2 : token.colorWhite,
      color: props.isRoot ? token.colorWhite : undefined,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      bottom: -10,
      left: 'calc(50% - 17px)',
      fontSize: 14,
      fontWeight: 500
    },
    content: {
      height: '100%'
    }
  })
)
